import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { SecondaryColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $pagination': {
      '& .MuiPaginationItem-root': {
        color: TextColors.dark,
      },
      '& .MuiPaginationItem-root.Mui-selected': {
        color: SecondaryColors.dark,
      },
    },
    '& $noResultsCta': {
      color: TextColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    '& $pagination': {
      '& .MuiPaginationItem-root': {
        color: TextColors.light,
      },
      '& .Mui-selected': {
        color: SecondaryColors.main,
      },
    },
    '& $noResultsCta': {
      color: TextColors.light,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
    },
    content: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(2),
      },
      [muiTheme.breakpoints.down('xs')]: {
        marginLeft: muiTheme.spacing(-4),
        marginRight: muiTheme.spacing(-4),
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
        overflow: 'hidden',
      },
    },
    card: {
      animation: 'enter 250ms ease-out',
      height: '100%',
    },
    pagination: {
      '& .MuiPagination-ul': {
        justifyContent: 'center',

        [muiTheme.breakpoints.up('md')]: {
          justifyContent: 'flex-end',
        },
      },

      '& .MuiPaginationItem-root': {
        ...typography.body1,
      },
      '& .MuiPaginationItem-page.Mui-selected': {
        background: 'transparent',
      },
    },
    noResultsCta: {},
  }),
  { name: 'GenMarketplaceResultBlock' },
);

export default useStyles;
